import React, { PropTypes } from 'react';
import { getSuccessText } from './util';

const Success = ({ authSystem, deviceType }) => (
    <div>
        <header className="dtc-auth__header" id="page-title">
            <h1 className="dtc-auth__header__title">Success!</h1>
        </header>
        <section className="dtc-auth__section dtc-auth__section--success" id="enter-code">
            <svg className="dtc-checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                <circle className="dtc-checkmark__circle" cx="26" cy="26" r="25" fill="none" />
                <path className="dtc-checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
            </svg>
            <p>{getSuccessText(authSystem, deviceType)}</p>
        </section>
    </div>
);

Success.propTypes = {
    authSystem: PropTypes.string,
    deviceType: PropTypes.string
};

export default Success;



// WEBPACK FOOTER //
// ./app/webapp/page/Activate/Success.js